var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#080431"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 23.52C12 18.0894 12 15.3741 13.69 13.6871C15.38 12 18.1 12 23.5401 12H24.5017C29.9418 12 32.6618 12 34.3518 13.6871C36.0418 15.3741 36.0418 18.0894 36.0418 23.52V24.48C36.0418 29.9106 36.0418 32.6259 34.3518 34.3129C32.6618 36 29.9418 36 24.5017 36H23.5401C18.1 36 15.38 36 13.69 34.3129C12 32.6259 12 29.9106 12 24.48V23.52Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7918 29.29C19.3123 29.29 16.1869 25.54 16.0566 19.3H18.8014C18.8916 23.88 20.915 25.82 22.5178 26.22V19.3H25.1024V23.25C26.6852 23.08 28.3478 21.28 28.9088 19.3L31.4934 19.3C31.0626 21.74 29.2595 23.54 27.9773 24.28C29.2595 24.88 31.3132 26.45 32.0945 29.29H29.2495C28.6384 27.39 27.1159 25.92 25.1024 25.72V29.29H24.7918Z",
    fill: "#080431"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.216d8a541b8eb524fa4090fab11adb6d.svg";
export { ForwardRef as ReactComponent };